import {
  trigger,
  transition,
  style,
  animate,
  stagger,
  query,
  state,
  animateChild,
  group,
} from '@angular/animations';
import { transitionDuration, transitionString } from '../../app/constants/transition';

export const modalStep = trigger('modalStep', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(1rem)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'translateY(0)',
      })
    ),
  ]),
]);

export const modal = trigger('modal', [
  transition(':enter', [
    style({ opacity: '0', transform: 'scale(0.95)' }),
    animate(
      transitionString,
      style({
        opacity: '1',
        transform: 'scale(1)',
      })
    ),
  ]),
  transition(':leave', [
    animate(
      transitionString,
      style({
        opacity: '0',
        transform: 'scale(0.95)',
      })
    ),
  ]),
]);

export const modalBackdrop = trigger('modalBackdrop', [
  transition(':enter', [
    group([
      query('@modal', [animateChild()]),
      style({ opacity: '0' }),
      animate(
        transitionString,
        style({
          opacity: '1',
        })
      ),
    ]),
  ]),
  transition(':leave', [
    group([
      query('@modal', [animateChild()]),
      animate(
        transitionString,
        style({
          opacity: '0',
        })
      ),
    ]),
  ]),
]);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0, position: 'absolute', width: '100%' }),
    animate(transitionString, style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ opacity: 1, position: 'absolute', width: '100%' }),
    animate(transitionString, style({ opacity: 0 })),
  ]),
]);

export const fadeInOutUp = trigger('fadeInOutUp', [
  transition(':enter', [
    style({ opacity: 0, 'margin-top': '2em' }),
    animate(transitionString, style({ opacity: 1, 'margin-top': '0' })),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
      'margin-top': '0',
      'margin-bottom': '*',
      'padding-top': '*',
      'padding-bottom': '*',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        'margin-top': '-2em',
        'margin-bottom': '0',
        'padding-top': '0',
        'padding-bottom': '0',
      })
    ),
  ]),
]);

export const toastInOut = trigger('toastInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-1rem) scale(0.9)' }),
    animate(transitionString, style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0) scale(1)' }),
    animate(
      transitionString,
      style({
        opacity: 0,
        transform: 'translateY(-1rem) scale(0.9)',
        height: 0,
        'margin-bottom': 0,
      })
    ),
  ]),
]);

export const saveOverlay = trigger('saveOverlay', [
  transition(':enter', [
    style({ opacity: '0', transform: 'translateY(30px)' }),
    animate(
      '0.3s cubic-bezier(.68,-1.6,.32,2.6)',
      style({
        opacity: '1',
        transform: 'translateY(0)',
      })
    ),
  ]),
  transition(':leave', [
    animate(
      '0.3s cubic-bezier(.68,-1.6,.32,2.6)',
      style({
        opacity: '0',
        transform: 'translateY(30px)',
      })
    ),
  ]),
]);

export const zoomInOutUpAbsolute = trigger('fadeInOut', [
  transition(':enter', [
    style({
      opacity: 0,
      position: 'absolute',
      transform: 'translateY(-20px) scale(1.05)',
    }),
    animate(transitionString, style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, position: 'absolute' }),
    animate(
      transitionString,
      style({ opacity: 0, transform: 'translateY(-20px) scale(1.05)' })
    ),
  ]),
]);

export const collapse = trigger('collapse', [
  transition(':enter', [
    style({
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      overflow: 'hidden',
      opacity: 0,
    }),
    animate(
      transitionString,
      style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        overflow: 'inherit',
        opacity: 1,
      })
    ),
  ]),
  transition(':leave', [
    animate(
      transitionString,
      style({
        height: '0',
        paddingTop: '0',
        paddingBottom: '0',
        overflow: 'hidden',
        opacity: 0,
      })
    ),
  ]),
]);

export const collapseZoom = trigger('collapseZoom', [
  transition(':enter', [
    style({
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0,
      overflow: 'hidden',
    }),
    animate(
      transitionString,
      style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        opacity: 1,
        overflow: 'hidden',
      })
    ),
  ]),
  transition(':leave', [
    animate(
      transitionString,
      style({
        height: '0',
        paddingTop: '0',
        paddingBottom: '0',
        opacity: 0,
        overflow: 'hidden',
      })
    ),
  ]),
]);

export const illustration = trigger('illustration', [
  transition('void => *, :enter', [
    style({
      opacity: 0,
      transform: 'scale(0.98)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
  transition('* => void, :leave', [
    style({
      opacity: 0,
      transform: 'scale(0.98)',
    }),
  ]),
]);

export const viewLoader = trigger('viewLoader', [
  transition('void => *, :enter, * => *', [
    style({
      opacity: 0,
      transform: 'scale(0.99)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
  transition('* => void, :leave', [
    style({
      opacity: 1,
      transform: 'scale(1)',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        transform: 'scale(0.99)',
      })
    ),
  ]),
]);
export const viewLoaderDelay = trigger('viewLoaderDelay', [
  transition('void => *, :enter', [
    style({
      opacity: 0,
      transform: 'scale(0.99)',
    }),
    animate(
      `${transitionDuration} ${transitionString}`,
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
  transition('* => void, :leave', [
    style({
      opacity: 1,
      transform: 'scale(1)',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        transform: 'scale(0.99)',
      })
    ),
  ]),
]);

export const viewLoaderLoading = trigger('viewLoaderLoading', [
  transition('void => *, :enter', [
    style({
      opacity: 0,
      transform: 'scale(0.99)',
    }),
    animate(
      `${transitionDuration} ${transitionString}`,
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
]);

export const staggerLoader = trigger('staggerLoader', [
  transition('void => *, :enter', [
    query(
      '.stagger-loader',
      [
        style({
          opacity: 0,
          transform: 'scale(0.9)',
        }),
        stagger(30, [
          animate(
            `${transitionString}`,
            style({
              opacity: 1,
              transform: 'scale(1)',
            })
          ),
        ]),
      ],
      { optional: true }
    ),
  ]),
]);

export const jobListStagger = trigger('jobListStagger', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({
          opacity: 0,
          transform: 'translateY(10px) scale(0.98)',
        }),
        stagger(15, [
          animate(
            '160ms cubic-bezier(0.2, 0, 0, 1)',
            style({
              opacity: 1,
              transform: 'none',
            })
          ),
        ]),
      ],
      { optional: true }
    ),
  ]),
]);

export const loginAnimation = trigger('loginAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      position: 'absolute',
      transform: 'scale(0.95)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        position: 'absolute',
        transform: 'scale(1)',
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
      position: 'absolute',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        position: 'absolute',
        transform: 'scale(1.05)',
      })
    ),
  ]),
]);

export const loginBackgroundAnimation = trigger('loginBackgroundAnimation', [
  transition(':leave', [
    style({
      opacity: 1,
      position: 'absolute',
      //transform: 'scale(1)',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        position: 'absolute',
        //transform: 'scale(2)',
      })
    ),
  ]),
]);

export const authenticationAnimation = trigger('authenticationAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'scale(0.98)',
      //filter: 'blur(10px)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'scale(1)',
        //filter: 'blur(0px)',
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
      transform: 'scale(1)',
      //filter: 'blur(0px)',
    }),
    animate(
      transitionString,
      style({
        opacity: 0,
        transform: 'scale(1.02)',
        //filter: 'blur(10px)',
      })
    ),
  ]),
]);

export const scaleFadeIn = trigger('scaleFadeIn', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'scale(0.95)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
]);

export const simpleFade = trigger('simpleFade', [
  transition('void => *, :enter', [
    style({
      opacity: 0,
    }),
    animate(
      `${transitionString}`,
      style({
        opacity: 1,
      })
    ),
  ]),
  transition('* => void, :leave', [
    style({
      opacity: 0,
    }),
  ]),
]);

export const collapseByState = trigger('collapse', [
  state(
    'open, void',
    style({
      height: '*',
      paddingTop: '*',
      paddingBottom: '*',
      overflow: 'inherit',
      opacity: 1,
    })
  ),
  state(
    'closed',
    style({
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      overflow: 'hidden',
      opacity: 0,
    })
  ),
  transition('open => closed, closed => open', [animate(transitionString)]),
]);

export const modalStepSlow = trigger('modalStepSlow', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(2rem)',
    }),
    animate(
      transitionString,
      style({
        opacity: 1,
        transform: 'translateY(0)',
      })
    ),
  ]),
]);

export const messageAnimation = trigger('messageAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'scale(0.9) translateY(10px)',
    }),
    animate(
      '150ms ease',
      style({
        opacity: 0.66,
        transform: 'scale(1.02)',
      })
    ),
    animate(
      '50ms ease',
      style({
        opacity: 1,
        transform: 'scale(1)',
      })
    ),
  ]),
]);

export const checklistItem = trigger('checklistItem', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(10px)' }),
    animate(
      `${transitionDuration} ${transitionString}`,
      style({ opacity: 1, transform: 'translateY(0)' })
    ),
  ]),
  transition(':leave', [
    animate(
      transitionString,
      style({ opacity: 0, transform: 'translateY(-10px)' })
    ),
  ]),
]);
